import React, { useEffect, useState } from "react";
import Layout from "../UI/Layout.jsx";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

const Dashboard = () => {
  const [user, setUser] = useState({ name: "", role: "" });
  const [greeting, setGreeting] = useState("");

  // Get the current time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  useEffect(() => {
    const userData = localStorage.getItem("userDATA");
    if (userData) {
      setUser(JSON.parse(userData)); // Set user data state
    }
    setGreeting(getGreeting()); // Set dynamic greeting based on time
  }, []);

  return (
    <Layout activePage="dashboard">
      <div className="dashboard-container">
        <div className="welcome-card">
          <h1>
            {greeting}, {user.name} 👋
          </h1>
          <p className="role">{user.role}</p>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
